import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'any'
})
export class MessageService {

  public errorTemplate: TemplateRef<any>;
  public errorMessage: string = '';
  public showError: boolean;

  public successTemplate: TemplateRef<any>;
  public successMessage: string = '';
  public showSuccess: boolean;

  constructor() {
    this.clearErrors();
    this.clearSuccess();
  }

  public setError(error) {
    this.clearSuccess();
    if (typeof (error) == 'string') {
      this.errorMessage = error;
    }
    else if (error instanceof TemplateRef) {
      this.errorTemplate = error;
    }
    else if (error instanceof Object) {
      if (error.errors) {
        this.errorMessage = error.errors;
      }
      else if (error.errorMessage) {
        this.errorMessage = error.errorMessage;
      }
    }

    this.showError = true;
  }

  public clearErrors() {
    this.showError = false;
    this.errorMessage = '';
    this.errorTemplate = null;
  }

  public setSuccess(message) {
    this.clearErrors();
    if (message instanceof TemplateRef) {
      this.successTemplate = message;
    }
    else {
      this.successMessage = message;
    }
    this.showSuccess = true;
  }

  public clearSuccess() {
    this.showSuccess = false;
    this.successMessage = '';
    this.successTemplate = null;
  }
}
